module.exports = __webpack_public_path__ + "static/media/iconsuccesDialog.2ae08d0e.svg";